/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import UserDataContent from "components/content/UserDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * System user management page.
 * 
 * Features:
 * - Paginated list of all system users
 * - User role and permission management
 * - Account status control (active, inactive, locked)
 * - User creation and profile editing
 * - Password reset functionality
 * - Access audit trail
 * - Role-based access control (RBAC) configuration
 * 
 * @returns Users management page component
 */
const UserPage: React.FC = () => {
  return (
    <DefaultDashboardLayout>
      <UserDataContent />
    </DefaultDashboardLayout>
  );
};

export default UserPage;

